import "./ContactSection.css";
import "../../index.css";

import AnchorCover from "../AnchorCover/AnchorCover";
import CoverTitle from "../CoverTitle/CoverTitle";
import StandardText from "../StandardText/StandardText";
import ContactGroup from "../ContactGroup/ContactGroup";
import BoldText from "../BoldText/BoldText";
import SocialLinks from "../SocialLinks/SocialLinks";

const ContactSection = ({
  title,
  bg = null,
  contentList = [],
  class_Name = ""
}) => {

  let iconList = [{
    url: "https://www.instagram.com/rosebornefilmandphoto?igsh=MW5kM213dXFpcDN5Mw==",
    icon: "fab fa-instagram",
    label: "Instagram"
},{
    url: "https://www.instagram.com/rosebornefilmandphoto?igsh=MW5kM213dXFpcDN5Mw==",
    icon: "fab fa-facebook",
    label: "Facebook"
},
{
    url: "https://www.instagram.com/rosebornefilmandphoto?igsh=MW5kM213dXFpcDN5Mw==",
    icon: "fab fa-youtube",
    label: "Youtube"
}]

  return (
    <div className={`contact-container ${bg && bg} flex-column-centered`}>
          <div className="contact-headline-container flex-column-centered">
            <CoverTitle clr={'clr-dark-red'}  marginClass="centered-text margin-bottom-1" class_Name={"font-size-4"}>
              Have a project in mind?
            </CoverTitle>
            <StandardText clr={'clr-dark-blue'} marginClass="contact-title centered-text margin-bottom-6" class_Name={"font-size-2"}>
              Or want to collaborate? Get in contact using the links below!
            </StandardText>
          </div>
          
          <ContactGroup  title="Phone" iconClass="fa-solid fa-phone" clr={'clr-dark-red'} marginClass="margin-bottom-3">
            <BoldText  clr={'clr-dark-red'}  marginClass="contact-title centered-text margin-bottom-3 font-size-3">
                Phone
              </BoldText>
            <AnchorCover class_Name={"border-dark-blue centered-margin margin-bottom-6"} href="tel:+18456622492" target="_blank" rel="noopener noreferrer" 
              paddingClass={'contact-button-padding'}
            >
              <StandardText class_Name={`font-size-1`} clr={'clr-dark-blue'} marginClass="margin-bottom-1">
              +1 (321) 485-6615
            </StandardText>
            </AnchorCover>
            
          </ContactGroup>

          <ContactGroup  title="Email" iconClass="fa-solid fa-envelope" clr={'clr-dark-red'} marginClass="margin-bottom-3">
            <BoldText  clr={'clr-dark-red'}  marginClass="contact-title centered-text margin-bottom-3 font-size-3">
                Email
              </BoldText>
            <AnchorCover class_Name={"border-dark-blue centered-margin margin-bottom-6"} href="mailto:info@rosebornefilmandphoto.com" target="_blank" rel="noopener noreferrer"
              paddingClass={'contact-button-padding'}
            >
              <StandardText class_Name={`font-size-1`} clr={'clr-dark-blue'} marginClass="margin-bottom-1">
              SEND MESSAGE
            </StandardText>
            </AnchorCover>
          </ContactGroup>

          <ContactGroup  title="Social Media" iconClass="fa-solid fa-hashtag" clr={'clr-dark-red'} marginClass="margin-bottom-3">
            <BoldText  clr={'clr-dark-red'}  marginClass="contact-title centered-text margin-bottom-3 font-size-4">
                Social Media
              </BoldText>
            <div className="flex-column-centered">
              <SocialLinks links={iconList} class_Name="clr-dark-blue visited-dark-blue"/>
            </div>
          </ContactGroup>
          
    </div>
  );
};

export default ContactSection;